import Store from '~store/store'
import { i18n } from '~src/i18n'
import { router } from '~router/router'
import Uploader from '~plugins/upload/uploader'

export default {
  install(Vue) {
    const _watch = new Vue({
      data: function () {
        return {
          uploaders: {},
          percentCompleted: 0
        }
      }
    })

    const getUploader = props => {
      if (_watch.uploaders[props.thread]) return _watch.uploaders[props.thread]

      const uploader = new Uploader({
        router,
        Store,
        i18n,
        propsData: props
      })

      uploader.$on('all-complete', unregisterUploader)
      uploader.$on('cancel-all', unregisterUploader)
      return registerUploader(uploader)
    }

    const registerUploader = uploader => {
      Vue.set(_watch.uploaders, uploader.thread, uploader)
      return uploader
    }

    const unregisterUploader = thread => {
      if (_watch.uploaders[thread]) {
        Vue.set(_watch.uploaders, thread, null)
        Vue.delete(_watch.uploaders, thread)
      }
    }

    const anyUploadInProgress = () => {
      let result = false
      let key

      for (key in _watch.uploaders) {
        if (_watch.uploaders[key].methods.getInProgress() > 0) {
          result = true
          break
        }
      }
      return result
    }
    Vue.prototype.$upload = {}
    Vue.prototype.$upload.getUploader = getUploader
    Vue.prototype.$upload.registerUploader = registerUploader
    Vue.prototype.$upload.unregisterUploader = unregisterUploader
    Vue.prototype.$upload.watch = _watch
    Vue.prototype.$upload.anyUploadInProgress = anyUploadInProgress
    Vue.prototype.$upload.percentCompleted = () => {
      return _watch.percentCompleted
    }
  }
}
